// src/app/application-insights.service.ts
import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ApplicationInsightsService {
  private angularPlugin = new AngularPlugin();
  private app?: ApplicationInsights;

  private currentFeature = 'unknown';
  private unitId?: string;

  init(router: Router, cfg: any) {
    this.app = new ApplicationInsights({
      config: {
        connectionString: cfg.connectionString,           // ✅ connection string
        enableAutoRouteTracking: !!cfg.enableAutoRouteTracking,
        extensions: [this.angularPlugin],
        extensionConfig: { [this.angularPlugin.identifier]: { router } },
        correlationHeaderExcludedDomains: cfg.correlationHeaderExcludedDomains || []
      }
    });
    this.app.loadAppInsights();

    router.events.pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: any) => this.currentFeature = this.featureFromUrl(e.urlAfterRedirects || e.url));

    this.app.addTelemetryInitializer((item: any) => {
      const base = item?.baseData; if (!base) return;
      base.properties = base.properties || {};
      base.properties.feature = this.currentFeature;
      if (this.unitId) base.properties.unitId = this.unitId;
    });
  }

  setContext(opts: { unitId?: string }) { this.unitId = opts.unitId ?? this.unitId; }
  setUser(id: string) { this.app?.setAuthenticatedUserContext(id); }
  clearUser() { this.app?.clearAuthenticatedUserContext(); }
  logEvent(name: string, props?: Record<string, any>) { this.app?.trackEvent({ name }, props); }
  logTrace(message: string, props?: Record<string, any>) { this.app?.trackTrace({ message }, props); }
  logPageView(name?: string) { this.app?.trackPageView({ name }); }
  logException(ex: Error, severityLevel?: number) { this.app?.trackException({ exception: ex, severityLevel }); }

  private featureFromUrl(url: string) {
    try { const path = url.split('?')[0].replace(/^\//,''); return path.split('/')[1] || 'home'; }
    catch { return 'unknown'; }
  }
}